import { routeConstants, routeName } from '../../routes/route-constants';
import { openReportState } from 'app/area/favourite/constants';

export function toCodeSelectView(breadcrumbs: string): string {
  return `/select/codetableadministration${breadcrumbs}`;
}

export function toCaseView(caseNumber: number): string {
  return `/case/${caseNumber}`;
}

export function toCaseEdit(caseNumber: number, entityPath: string): string {
  return `/case/${caseNumber}${entityPath}/edit`;
}

export function toCaseEditInModal(basePath: string, caseNumber: number, entityPath: string): string {
  return `${basePath}/case/${caseNumber}${entityPath}/edit`;
}

export function toCaseViewEvaluation(caseNumber: number, entityPath: string, sectionNumber: number): string {
  return `/case/${caseNumber}/${entityPath}?section=${sectionNumber}`;
}

export function toCaseDuplicate(caseNumber: number): string {
  return `/case/${caseNumber}/duplicate`;
}

export function toCreateCase(caseTypeId: number): string {
  return `/create/${caseTypeId}`;
}

export function toDraft(draftId: number, entityPath: string): string {
  return `/draft/${draftId}${entityPath}`;
}

export function toDraftInModal(draftId: number, entityPath: string): string {
  return `/case/draft/${draftId}${entityPath}`;
}

export function toCaseListing(favouriteId: number): string {
  return `/${routeName.Favourite}/draft/${favouriteId}`;
}

export function toCaseViewModalCaseListing(favouriteId: number, caseId: number): string {
  return `/${routeName.Favourite}/${routeName.Draft}/${favouriteId}/${routeName.Case}/${caseId}`;
}

export function toDraftCaseViewModalCaseListing(favouriteId: number, draftId: number, entityPath: string = ''): string {
  return `/${routeName.Favourite}/${routeName.Draft}/${favouriteId}/${routeName.Case}/${routeName.Draft}/${draftId}${entityPath}`;
}

export function toUpdateSavedReport(favouriteId: number): string {
  return `/${routeName.Favourite}/${favouriteId}/${openReportState.edit}`;
}

export function toSearchViewWithQuery(query: string): string {
  return `${routeConstants.createFavouriteDraft}?query=${encodeURIComponent(query)}`;
}

export function toDashboardView(dashboardType: number): string {
  return `/${routeName.Dashboard}/${dashboardType}/${routeName.Favourite}/${routeName.Draft}`;
}

export function toCaseViewModalDashboard(dashboardType: number, favouriteId: number, caseId: number): string {
  return `/${routeName.Dashboard}/${dashboardType}/${routeName.Favourite}/${routeName.Draft}/${favouriteId}/${routeName.Case}/${caseId}`;
}
export function toDraftCaseViewModalDashboard(dashboardType: number, favouriteId: number, draftId: number, 
  entityPath: string = ''): string {
  return `/${routeName.Dashboard}/${dashboardType}/${routeName.Favourite}/${routeName.Draft}/${favouriteId}/${routeName.Case}/${routeName.Draft}/${draftId}${entityPath}`;
}

export function toCaseViewModalStartupDashboard(caseId: number): string {
  return `/${routeName.startup}/${routeName.Dashboard}/${routeName.Case}/${caseId}`;
}

export function toDraftCaseViewModalStartupDashboard(draftId: number, entityPath: string = ''): string {
  return `/${routeName.startup}/${routeName.Dashboard}/${routeName.Case}/${routeName.Draft}/${draftId}${entityPath}`;
}

export function toDraftCaseViewModalMyCaseDrafts(draftId: number, entityPath: string = ''): string {
  return `/${routeName.MyCaseDrafts}/${routeName.Case}/${routeName.Draft}/${draftId}${entityPath}`;
}

export function toSavedDashboard(favouriteId: number, dashboardType: number, queryParams?: string): string {
  return `/${routeName.Dashboard}/${dashboardType}/${routeName.Favourite}/${favouriteId}${queryParams || ''}`;
}

export function toUpdateSavedDashboard(favouriteId: number, dashboardTypeId: number): string {
  return `/${routeName.Dashboard}/${dashboardTypeId}/${routeName.Favourite}/${favouriteId}/${openReportState.edit}`;
}

export function toDashboardDraftFavourite(favouriteId: number, dashboardType: number): string {
  return `/${routeName.Dashboard}/${dashboardType}/${routeName.Favourite}/${routeName.Draft}/${favouriteId}`;
}

export function toBowtie(caseNumber: number): string {
  return `/${routeName.Bowtie}/${caseNumber}`;
}

export function toCaseViewModalBowtie(bowtieViewCaseNumber: number, modalViewCaseNumber: number): string {
  return `/${routeName.Bowtie}/${bowtieViewCaseNumber}/${routeName.Case}/${modalViewCaseNumber}`;
}

export function toDraftCaseViewModalBowtie(bowtieViewCaseNumber: number, modalViewDraftNumber: number, entityPath: string = ''): string {
  return `/${routeName.Bowtie}/${bowtieViewCaseNumber}/${routeName.Case}/${routeName.Draft}/${modalViewDraftNumber}${entityPath}`;
}

export function toCompanyReportDraftFavourite(favouriteId: number, companyReportId: number, queryParams?: string): string {
  return `/${routeName.CompanyReport}/${companyReportId}/${routeName.Favourite}/draft/${favouriteId}${queryParams || ''}`;
}

export function toSavedCompanyReport(favouriteId: number, companyReportId: number, queryParams?: string): string {
  return `/${routeName.CompanyReport}/${companyReportId}/${routeName.Favourite}/${favouriteId}${queryParams || ''}`;
}

export function toUpdateSavedCompanyReport(favouriteId: number, companyReportId: number): string {
  return `/${routeName.CompanyReport}/${companyReportId}/${routeName.Favourite}/${favouriteId}/${openReportState.edit}`;
}

export function toCaseSaveAsDraftView(draftNumber: number, entityPath: string): string {
  return `/draft/${draftNumber}${entityPath}/save`;
}
